class Logger {
    constructor() {
        this.logs = [];
        this.level = 'info';
        this.maxLogs = 1000;
    }

    log(level, message, data = null) {
        const timestamp = new Date().toISOString();
        const logEntry = {
            timestamp,
            level,
            message,
            data,
            id: `${timestamp}-${Math.random().toString(36).substr(2, 9)}`
        };

        this.logs.push(logEntry);
        
        if (this.logs.length > this.maxLogs) {
            this.logs.shift();
        }

        if (process.env.NODE_ENV !== 'production') {
            const consoleMethod = {
                'error': console.error,
                'warn': console.warn,
                'info': console.info,
                'debug': console.debug
            }[level] || console.log;
            
            consoleMethod(`[${timestamp}] ${level.toUpperCase()}: ${message}`, data || '');
        }
    }

    error(message, data = null) {
        this.log('error', message, data);
    }

    warn(message, data = null) {
        this.log('warn', message, data);
    }

    info(message, data = null) {
        this.log('info', message, data);
    }

    debug(message, data = null) {
        this.log('debug', message, data);
    }

    getLogs(level = null, limit = 100) {
        let filteredLogs = this.logs;
        
        if (level) {
            filteredLogs = this.logs.filter(log => log.level === level);
        }
        
        return filteredLogs.slice(-limit);
    }

    clearLogs() {
        this.logs = [];
    }

    exportLogs() {
        const logData = JSON.stringify(this.logs, null, 2);
        const blob = new Blob([logData], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `solar-finance-logs-${new Date().toISOString().split('T')[0]}.json`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }
}

export const logger = new Logger();
export default logger;